import State from 'interfaces/state/State';

export const avatar$ = (state: State): string => state.newJobAvatar.avatar;
export const fileId$ = (state: State): string => state.newJobAvatar.fileId;
export const isLoading$ = (state: State): boolean => state.newJobAvatar.isLoading;
export const isError$ = (state: State): boolean => state.newJobAvatar.isError;
